export type DiffLine = {
  kind: 'same' | 'added' | 'removed';
  value: string;
};

function longestCommonSubsequence(a: string[], b: string[]): number[][] {
  const m = a.length;
  const n = b.length;
  const dp: number[][] = Array.from({ length: m + 1 }, () => new Array(n + 1).fill(0));
  for (let i = 1; i <= m; i++) {
    for (let j = 1; j <= n; j++) {
      if (a[i - 1] === b[j - 1]) {
        dp[i][j] = dp[i - 1][j - 1] + 1;
      } else {
        dp[i][j] = Math.max(dp[i - 1][j], dp[i][j - 1]);
      }
    }
  }
  return dp;
}

function backtrack(
  dp: number[][],
  a: string[],
  b: string[],
  i: number,
  j: number,
  result: DiffLine[]
): void {
  if (i === 0 && j === 0) return;
  if (i > 0 && j > 0 && a[i - 1] === b[j - 1]) {
    backtrack(dp, a, b, i - 1, j - 1, result);
    result.push({ kind: 'same', value: a[i - 1] });
  } else if (j > 0 && (i === 0 || dp[i][j - 1] >= dp[i - 1][j])) {
    backtrack(dp, a, b, i, j - 1, result);
    result.push({ kind: 'added', value: b[j - 1] });
  } else if (i > 0) {
    backtrack(dp, a, b, i - 1, j, result);
    result.push({ kind: 'removed', value: a[i - 1] });
  }
}

export function computeLineDiff(oldText: string, newText: string): DiffLine[] {
  const a = oldText.split('\n');
  const b = newText.split('\n');

  if (oldText === newText) {
    return a.map((line) => ({ kind: 'same' as const, value: line }));
  }

  const dp = longestCommonSubsequence(a, b);
  const result: DiffLine[] = [];
  backtrack(dp, a, b, a.length, b.length, result);
  return result;
}

export function isTextChanged(oldText: string, newText: string): boolean {
  return oldText !== newText;
}

export type VersionEntry = {
  version: number;
  text: string;
  date: string;
};

